// extracted by mini-css-extract-plugin
module.exports = {"grayLine":"jS"};